<template>
    <div :class="['abonement', `abonement-index-${index}`, `abonement-id-${subscription.idsubscription}`, {'active' : active}]"
         @click="selected">
        <div>
            <base-button class="mt-lg-3 mt-1 w-100 red-btn d-lg-none d-block"
                         @click.stop="order"
                         :disabled="disableOrderIfNotActive && !active"
                         :data-id="subscription.idsubscription"
                         data-model="subscription"
                         :data-price="subscription.price"
                         data-action="order"
                         :data-label="orderTitle">
                {{ orderTitle }}
            </base-button>
        </div>
        <div>
            <span class="abonemet-radio"></span>
            <span class="abonement-title">{{ title }}</span>
            <span class="abonement-duration">{{ subscription.subscription }}</span>
            <span class="abonement-price">{{ price }}</span>
            <span class="abonement-price-before">{{ priceBefore }}</span>
            <div class="abonement-price-lesson">&nbsp;{{ subscription.description }}</div>
            <div
                    class="abonement-course-bonus"
                    v-if="subscription.courses && subscription.courses.length > 0">
                <span :title="courseBonusTitle"><img
                        src="@/assets/hometeacher/images/course-present.png"><span
                        @click.stop="showPresents = !showPresents"><span
                        v-if="subscription.courses.length > 1">{{ $t('courses') }}</span><span v-else>{{ $t('course') }}</span> {{ $t('as_gift') }}!</span></span>

                <CoursePresents v-if="showPresents"
                                @more="bonusCourseClick"
                                @close="showPresents = false"
                                :courses="subscription.courses"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import numeral from 'numeral';
    import CoursePresents from "../CourseComponents/present/CoursePresents";
    import i18n from './../../i18n';

    export default {
        name: "SubscriptionItem",
        components: {CoursePresents},
        props: {
            subscription: {type: Object},
            title: {type: String, default: ""},
            orderTitle: {type: String, default: i18n.t('buy')},
            index: {type: Number, default: null},
            active: {type: Boolean, default: false},
            disableOrderIfNotActive: {type: Boolean, default: false},
        },
        methods: {
            selected() {
                this.$emit("selected", this.subscription);
            },

            order() {
                this.$emit("order", this.subscription);
            },

            bonusCourseClick() {
                this.$emit("bonusCourseClick", this.subscription);
            },

        },

        data() {
            return {
                showPresents: false,
            }
        },

        computed: {
            price() {
                if (this.subscription.price && this.subscription.price > 0) return numeral(this.subscription.price).format("0,0").replace(/,/g, '\u00A0') + '\u00A0' + this.$t('cur')
                return this.$t('free');
            },

            priceBefore() {
                if (this.subscription.pricebefore && this.subscription.pricebefore > 0) return numeral(this.subscription.pricebefore).format("0,0").replace(/,/g, '\u00A0') + '\u00A0' + this.$t('cur')
                return null;
            },

            courseBonusTitle() {
                if (this.subscription.courses && this.subscription.courses.length > 0) {
                    let courseNames = this.subscription.courses.map(c => c.course);
                    return "Купите абонемент и получите в подарок: \u000d" + courseNames.join(",\u000d ")
                }
                return "";
            },
        },

        filters: {}

    }
</script>

<style scoped>

    @media (max-width: 991.8px) {
        .abonement-price, .abonement-price-before {
            float: none !important;
            margin-right: 10px;
        }

        .abonement-duration {
            display: block;
        }

        .abonement-price-lesson {
            text-align: left !important;
            padding-left: 40px;
        }

        .abonement-price {
            padding-left: 40px;
        }

        .abonement {
            text-align: left;
        }

    }

    .abonement-course-bonus {
        text-align: right;
        cursor: pointer;
        font-family: "Manrope Bold";
        color: #ed1c24;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .abonement-course-bonus > span {
        font-size: 16px;
        background-color: #fff256;
        padding-top: 0px;
        padding-bottom: 3px;
        padding-left: 4px;
        padding-right: 4px;
    }

    .abonement-course-bonus > span > span {
        border-bottom: dashed 1px;
    }

    .abonement-course-bonus > span > img {
        margin-right: 4px;
        margin-bottom: 2px;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        position: absolute;
        width: 120px !important;
        right: 5px;
        top: 6px;
        font-size: 12px;
        line-height: 12px;
        padding-left: 0;
        padding-right: 0;
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: 1px 1px 2px white;
    }

    .active .red-btn, .red-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }


    .abonement-price, .abonement-price-before {
        float: right;
    }


    .abonement {
        position: relative;
        cursor: pointer;
    }

    .abonement.disabled {
        cursor: no-drop;
    }

    .abonement-title {
        font-size: 14px;
        font-family: Manrope Bold;
        color: #8b8496;
    }

    .abonement-duration {
        color: #de0035;
        font-size: 16px;
        font-family: Manrope Bold;
        margin-left: 40px;
    }

    .abonement-price {
        color: #231c37;
        font-size: 18px;
        font-family: Manrope Bold;
    }

    .abonement-price-before {
        color: #8b8496;
        font-size: 14px;
        text-decoration: line-through;
        margin-top: 4px;
        margin-right: 5px;
    }

    .abonement-price-lesson {
        color: #8b8496;
        font-family: Manrope Bold;
        font-size: 16px;
        text-align: right;
        clear: both;
    }

    .abonemet-radio {
        position: absolute;
        display: block;
        border: 1px solid #b2c3d6;
        height: 20px;
        width: 20px;
        left: 5px;
        top: 2px;
        border-radius: 50%;
    }

    .active.abonement .abonemet-radio::after {
        display: block;
    }

    .abonement .abonemet-radio::after {
        background-color: #5ab947;
        display: none;
        content: " ";
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 5px solid white;
        padding: 1px;
        box-sizing: border-box;
    }

    .abonement-price span {
        font-size: 18px;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 30px;
        font-size: 18px;
        color: #231c37;
        font-family: "Manrope Bold";
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }


</style>
